import services from "../services";
import Utils from "../Utils";

const strict = true;

const getDefaultState = () => {
  return {
    memberList: [],
    memberName: null,
    memberSurname: null,
    memberBirthDate: null,
    memberFiscalCode: null,
    activeMember: null,
    filterCriteriaResults: ""
  };
};

const state = getDefaultState();

const getters = {
  memberList: state => state.memberList,
  memberById: state => memberId => {
    return state.memberList.find(member => member.memberId == memberId);
  },
  memberByFiscalCode: state => fiscalCode => {
    return state.memberList.find(member => member.vatCode == fiscalCode);
  },
  numberOfMembers: state => state.memberList.length,
  getActiveMember: state => state.activeMember,
  filterCriteriaResults: state => state.filterCriteriaResults,
  memberName: state => state.memberName,
  memberSurname: state => state.memberSurname,
  memberBirthDate: state => state.memberBirthDate,
  memberFiscalCode: state => state.memberFiscalCode
};

const mutations = {
  RESET(state) {
    // acquire initial state
    const s = getDefaultState();
    Object.keys(s).forEach(key => {
      state[key] = s[key];
    });
  },
  setActiveMember(state, member) {
    state.activeMember = member;
  },
  SET_MEMBER_LIST(state, memberList) {
    state.memberList = memberList;
  },
  RESET_MEMBER_SEARCH(state) {
    state.memberName = null;
    state.memberSurname = null;
    state.memberBirthDate = null;
    state.memberFiscalCode = null;
    state.memberList = [];
    state.filterCriteriaResults = "";
  },
  SET_MEMBER_NAME(state, name) {
    state.memberName = name;
  },
  SET_MEMBER_SURNAME(state, surname) {
    state.memberSurname = surname;
  },
  SET_MEMBER_BIRTHDATE(state, birthdate) {
    state.memberBirthDate = birthdate;
  },
  SET_MEMBER_FISCAL_CODE(state, fiscalCode) {
    state.memberFiscalCode = fiscalCode;
  },
  SET_FILTER_CRITERIA_RESULTS(state) {
    if (state.memberFiscalCode) {
      state.filterCriteriaResults = `'${state.memberFiscalCode}'`;
    } else {
      // NOTE! stored date is in american format mm/dd/yyyy
      let [y, m, d] = state.memberBirthDate.split("-");
      state.filterCriteriaResults = `'${state.memberName} ${state.memberSurname} - ${d}/${m}/${y}'`;
    }
  }
};

const actions = {
  async fetchMembers({ commit, state, rootGetters }) {
    let officeId = rootGetters["hfManagement/officeId"];
    let isSanimpresaOffice = rootGetters["hfManagement/isSanimpresaOffice"];
    let formattedDate = state.memberBirthDate;
    let parameters = {
      id: officeId,
      name: state.memberName,
      surname: state.memberSurname,
      birthDate: formattedDate,
      fiscalCode: state.memberFiscalCode,
      copertura: isSanimpresaOffice ? "SANI" : null
    };
    return services.membersService
      .fetchMembers(parameters)
      .then(memberList => {
        commit("SET_MEMBER_LIST", memberList);
        return Promise.resolve(memberList);
      })
      .catch(error => {
        commit("SET_MEMBER_LIST", []);
        let errorDialogDetails = {
          ...error
        };
        if (error.type == Utils.errorTypes.STATUS) {
          errorDialogDetails.dataName = "members";
        }
        commit("error/SET_ERROR", errorDialogDetails, {
          root: true
        });
        return Promise.reject(error);
      })
      .finally(() => {
        commit("SET_FILTER_CRITERIA_RESULTS");
      });
  },
  fetchMember({ commit }, payload) {
    return services.membersService
      .fetchMember(payload.officeId, payload.fiscalCode)
      .then(member => {
        commit("setActiveMember", member);
        return Promise.resolve(member);
      })
      .catch(error => {
        commit("activeMember", null);
        let errorDialogDetails = {
          ...error
        };
        if (error.type == Utils.errorTypes.STATUS) {
          errorDialogDetails.dataName = "members";
        }
        commit("error/SET_ERROR", errorDialogDetails, {
          root: true
        });
        return Promise.reject("Cannot retrieve member");
      });
  }
};

export default {
  namespaced: true,
  strict,
  state,
  getters,
  mutations,
  actions
};
